import { Component } from '@angular/core';

@Component({
  selector: 'app-loading-mask',
  standalone: true,
  imports: [],
  templateUrl: './loading-mask.component.html',
  styleUrl: './loading-mask.component.scss'
})
export class LoadingMaskComponent {

}
